/**
 * @flow
 */

import styled from 'react-emotion'
import { mobile, tablet } from '../../../utils/mixins'
import {
  Typo30WhiteThreeDDI,
  Typo30WhiteDI
} from '../../../themes/Fonts/Din2014'
import Colors from '../../../themes/Colors'

export const MainContainer = styled('div')`
  position: relative;
  min-height: 500px;
  width: 100%;
  background: url('https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/Team/team-page-desktop-bg.png'),
    linear-gradient(to bottom, ${Colors.blackDefault}, rgba(18, 18, 18, 0.4)),
    ${Colors.blackDefault};
  background-size: cover;
  background-position: 50% 100%;
`

export const IBCricketLogo = styled('img')`
  position: absolute;
  height: 105px;
  margin-top: 100px;
  margin-left: 20px;
  ${mobile} {
    height: 65px;
    margin-top: 72px;
    margin-left: unset;
  }
  ${tablet} {
    height: 95px;
  }
`

export const MainContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 500px;
`

export const Title = styled(Typo30WhiteThreeDDI)`
  text-align: center;
  line-height: normal;
  ${mobile} {
    font-size: 22px;
  }
  ${tablet} {
    font-size: 26px;
  }
  margin: 0;
`

export const Image = styled('img')`
  width: 107px;
  margin-top: 30px;
  margin-bottom: 30px;
  ${mobile} {
    width: 85px;
  }
  ${tablet} {
    width: 85px;
  }
`

export const Content = styled(Typo30WhiteDI)`
  margin-bottom: 55px;
  max-width: 500px;
  text-align: center;
  line-height: 1.4;
  letter-spacing: normal;
  ${mobile} {
    font-size: 22px;
  }
  ${tablet} {
    font-size: 26px;
  }
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/LandingSection/styledComponents.js